import React from 'react';
import ReactDOM from 'react-dom/client';
// Typsnitt från egen server i stället för Google Fonts (DPIA A5, beslut Erik 2026-11-01):
// kundens IP-adress ska inte skickas till Google vid varje sidladdning.
import '@fontsource/inter/latin-400.css';
import '@fontsource/inter/latin-500.css';
import '@fontsource/inter/latin-600.css';
import '@fontsource/inter/latin-700.css';
import '@fontsource/manrope/latin-600.css';
import '@fontsource/manrope/latin-700.css';
import '@fontsource/manrope/latin-800.css';
import './index.css';
import App from './App';
import { ToastContainer } from './Toast';
import { ConfirmDialogContainer } from './ConfirmDialog';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
    <ToastContainer />
    <ConfirmDialogContainer />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
